import { useEffect, useState, useRef } from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";
 
 
import { useLocation } from "react-router-dom";
 
 
 
 
import AppBar from '@mui/material/AppBar';
 
import Toolbar from '@mui/material/Toolbar';
 
import Typography from '@mui/material/Typography';
 
 
import Container from '@mui/material/Container';
 
 
 
 

const Header = () => {
  const history = useNavigate();
 const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

 
  const location = useLocation();
 
 
 

 
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  
  
 

  useEffect(() => {
    const pathname = location.pathname;

    // Now you can use the pathname variable as needed
    console.log("Current pathname:", pathname);
  }, []);

 
  
 

  return (
    <AppBar position="static" sx={{background: '#770A97'}}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
               
              
              
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Search Console
          </Typography>

          
             
             
               
           
           
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              
           
              
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
             Search Console
          </Typography>
           

           
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
